import { render, staticRenderFns } from "./userDataAlliance.vue?vue&type=template&id=7ac9fcf6&scoped=true&"
import script from "./userDataAlliance.vue?vue&type=script&lang=js&"
export * from "./userDataAlliance.vue?vue&type=script&lang=js&"
import style0 from "./userDataAlliance.vue?vue&type=style&index=0&id=7ac9fcf6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ac9fcf6",
  null
  
)

export default component.exports